var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-map',{ref:"map",attrs:{"center":_vm.center,"options":_vm.options,"zoom":_vm.zoom}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }